<app-skill-builder-select-list
	[mainTitle]="page.title"
	[subTitle]="page.subTitle2"
	[options]="options"
	[next]="next"
>
</app-skill-builder-select-list>
